module.exports = __webpack_public_path__ + "static/media/dry_van.804dfd52.jpg";